import {afterDomIsReady} from '../utils/whenLoaded';
import {initializeCalculatorStorage, initializePatientStorage} from '../stateHandler';
import {assert} from '../utils/assert';
import {getRangeInputByName, getRangeTickmarksByInputName, getSelectedOptionBySelectName} from '../utils/formFields';
import {loadTemplate} from '../utils/loadTemplate';
import {updateTickmarks} from '../utils/updateTickmarks';

export default () => afterDomIsReady(async () => {
	const templateEl = document.getElementById('pasi-template') as HTMLTextAreaElement;
	assert(templateEl !== null);
	const getTemplate = await loadTemplate('./pasi-template.html');

	const storage = initializeCalculatorStorage();

	const updateState = function (column: string, data: any) {
		storage.update('pasi', Object.assign({}, storage.get('pasi'), {
			[column]: data
		}))
	};
	const recountRow = (column: string, multiplicationScore: number): string => {
		const degree = getSelectedOptionBySelectName(`r${column}0`).value.split('-', 1)[0];

		const gravityErytem = getRangeInputByName(`r${column}1`).value;
		updateTickmarks(getRangeTickmarksByInputName(`r${column}1`), gravityErytem);

		const gravityIndurace = getRangeInputByName(`r${column}2`).value;
		updateTickmarks(getRangeTickmarksByInputName(`r${column}2`), gravityIndurace);

		const gravityDeskvamace = getRangeInputByName(`r${column}3`).value;
		updateTickmarks(getRangeTickmarksByInputName(`r${column}3`), gravityDeskvamace);

		const sum = (parseFloat(degree) * (parseFloat(gravityErytem) + parseFloat(gravityIndurace) + parseFloat(gravityDeskvamace)) * multiplicationScore);
		const sumAsString = sum.toFixed(1);
		document.getElementById(`pasi-form-r${column}0s`)!.innerText = sumAsString;
		updateState(column, {
			0: degree,
			1: gravityErytem,
			2: gravityIndurace,
			3: gravityDeskvamace,
			'0b': sumAsString,
		});

		return sumAsString;
	};
	const recount = () => {
		const head = recountRow('0', 0.1);
		const upper = recountRow('1', 0.2);
		const trunk = recountRow('2', 0.3);
		const lower = recountRow('3', 0.4);

		const total = parseFloat(head) + parseFloat(upper) + parseFloat(trunk) + parseFloat(lower);
		const totalAsString = total.toFixed(1);
		document.getElementById('pasi-score')!.innerText = totalAsString;
		updateState('celkem', totalAsString);

		const improvement50 = total * 0.5;
		const improvement50AsString = improvement50.toFixed(1);
		document.getElementById('pasi-50')!.innerText = improvement50AsString;
		updateState('improvement50', improvement50AsString);

		const improvement75 = total * 0.25;
		const improvement75AsString = improvement75.toFixed(1);
		document.getElementById('pasi-75')!.innerText = improvement75AsString;
		updateState('improvement75', improvement75AsString);

		const improvement90 = total * 0.1;
		const improvement90AsString = improvement90.toFixed(1);
		document.getElementById('pasi-90')!.innerText = improvement90AsString;
		updateState('improvement90', improvement90AsString);
	};

	// now
	recount();

	// and on every field change
	document.querySelectorAll('select').forEach(
		el => el.addEventListener('change', () => recount()));
	document.querySelectorAll('input[type=range]').forEach(
		el => el.addEventListener('input', () => recount()));
	// IE fix:
	document.querySelectorAll('input[type=range]').forEach(
		el => el.addEventListener('change', () => recount()));



	const resultEl = document.getElementById('pasi-downloadForm');
	assert(resultEl !== null);
	resultEl.addEventListener('submit', () => {
		let template = getTemplate();

		const pacient = initializePatientStorage().get();
		template = template.replace('{titul}', pacient.degree || '');
		template = template.replace('{jmeno}', pacient.firstName || '');
		template = template.replace('{prijmeni}', pacient.lastName || '');
		template = template.replace('{datumVysetreni}', pacient.examinationDate || '');

		const state = storage.get('pasi');
		for (let i = 0; i <= 3; i++) {
			for (let j = 0; j <= 3; j++) {
				template = template.replace(`{r${i}${j}}`, state[i][j]);
			}
			template = template.replace(`{r${i}0b}`, state[i]['0b']);
		}
		template = template.replace('{celkem}', state.celkem);
		template = template.replace('{pasi50}', state.improvement50);
		template = template.replace('{pasi75}', state.improvement75);
		template = template.replace('{pasi90}', state.improvement90);

		templateEl.value = template;
	});
});
